import i18n from 'i18next';

// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('supplier.complianceDocuments', {
    controller: 'SupplierComplianceDocumentsController as vm',
    url: '/compliance-documents',
    templateUrl:
      'main/supplier/complianceDocuments/complianceDocuments.tpl.html',
    data: { pageTitle: i18n.t('complianceDocumentDefinitions.title') },
  });
};

class SupplierComplianceDocumentsController {
  constructor($rootScope, supplier) {
    'ngInject';

    this.supplier = supplier;
    $rootScope.pageTitle = `${supplier.name || ''} - ${i18n.t(
      'complianceDocumentDefinitions.title',
    )}`;
  }
}

angular
  .module('main.supplier.complianceDocuments', [])
  .config(config)
  .controller(
    'SupplierComplianceDocumentsController',
    SupplierComplianceDocumentsController,
  );
